// extracted by mini-css-extract-plugin
export default {"container":"HelpService-module__container--_d5_4","text":"HelpService-module__text--y9fSq","iconWrap":"HelpService-module__iconWrap--nsQpU","icon":"HelpService-module__icon--_uYmS"};